"use client";

import { useAppSelector } from "@/store/hooks";
import type React from "react";

const HeroContent: React.FC = () => {
  const { data, loading, error } = useAppSelector((state) => state.content);

  // Show loading state
  if (loading) {
    return (
      <>
        <div className="mb-8">
          <div className="h-16 md:h-20 bg-white/20 rounded animate-pulse mb-4"></div>
          <div className="h-8 bg-white/10 rounded animate-pulse max-w-md mx-auto"></div>
        </div>
        <div className="mb-12">
          <div className="h-6 bg-white/10 rounded animate-pulse max-w-3xl mx-auto"></div>
        </div>
      </>
    );
  }

  // Show error message if error exists
  if (error) {
    return (
      <div className="text-center">
        <div className="mb-4 text-lg text-red-200 bg-red-500/20 rounded px-6 py-4 max-w-md mx-auto">
          {error}
        </div>
      </div>
    );
  }

  // Show error message if no data
  if (!data?.hero) {
    return (
      <div className="text-center">
        <div className="mb-4 text-lg text-red-200 bg-red-500/20 rounded px-6 py-4 max-w-md mx-auto">
          Unable to load hero content. Please try again later.
        </div>
      </div>
    );
  }

  return (
    <>
      {/* Restaurant Logo/Name */}
      <div className="mb-8">
        <h1 className="text-5xl md:text-7xl font-bold text-white mb-4">
          {data?.hero.title}
        </h1>
        <p className="text-xl md:text-2xl text-white/90 font-medium">
          {data?.hero.subtitle}
        </p>
      </div>

      {/* Hero Description */}
      <div className="mb-12">
        <p className="text-lg md:text-xl text-white/80 max-w-3xl mx-auto leading-relaxed">
          {data?.hero.description}
        </p>
      </div>
    </>
  );
};

export default HeroContent;
